/**
 * FGA (Fastest Growing Agencies) Default Page Redirect
 *
 * Redirects visitors from the generic 'fga-default-page' slug
 * to the current year's FGA landing page.
 *
 * @todo Remove this file when the FGA feature is rebuilt.
 *       Also remove:
 *       - The "fga-redirect" Parcel target in package.json
 *       - The "fga-redirect" entry in inc/enqueue.php $javascripts array
 */
( function () {
	'use strict';

	if ( window.location.pathname.indexOf( 'fga-default-page' ) === -1 ) {
		return
	}

	const url = new URL( window.location.href );
	url.pathname = '/fastest-growing-agencies/2025/';
	window.location.replace( url.toString() );
} )();
